import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MessServiceService, UtilityService } from '@app/shared/common';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  /**
   * @description
   * Enter new password to reset.
   */

  form: FormGroup;
  subscriptions: Subscription[] = [];
  user: { token: string; email: string } = {
    token: '',
    email: '',
  };
  toastMessage;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private messService: MessServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService
  ) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.user.token = this.route.snapshot.queryParams['token'];
    this.user.email = this.route.snapshot.queryParams['email'];

    this.form = this.fb.group({
      email: [this.user.email, Validators.required],
      password: ['', Validators.required],
      password_confirmation: ['', Validators.required],
      token: [this.user.token, Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.messService.clearErrors();
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onSubmit() {
    const formData = this.form.getRawValue();

    this.subscriptions.push(
      this.authService.resetPassword(formData).subscribe({
        next: (res: any) => {
          this.toastMessage = [
            {
              severity: 'success',
              summary: '',
              detail: res.message,
            },
          ];
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (error: any) => {
          this.toastMessage = [
            {
              severity: 'error',
              summary: '',
              detail: error.error.message,
            },
          ];
        },
      })
    );
  }
}
